// Haalt uit de legacy /database-catalogus elk effect van een sector die
// inmiddels uit de geversioneerde pipeline komt.
//
// Nodig omdat elke catalogus-lezer de twee pipelines achter elkaar plakt
// (mergeStandaardCatalogs) en niets ontdubbelt: zodra een sector gepind is,
// staat hij anders twee keer in de kiezer — onder de oude UUID en onder de uid
// uit het versiedocument, met dezelfde namen. Een nieuwe adoptie mag alleen nog
// de gepinde versie krijgen.
//
// ALLEEN voor lijsten waaruit gekozen wordt. De bedragenkaart
// (useMsiMonetaryScores, fetchMsiScores) leest /database bewust ongefilterd:
// bestaande effecten dragen nog de UUID tot de migratie ze omzet.
//
// Mirrored by functions/data/withoutPinnedSectors.js — parity is pinned by
// functions/data/withoutPinnedSectors.test.js.
//
// AI-CONTEXT: See docs/features/arbeidsparticipatie-1-0.md

/**
 * @typedef {object} LegacyCategory
 * @property {string} [id]
 * @property {string} [name]
 * @property {Array<{id: string, sectors?: Array<string>}>} [effects]
 */

/**
 * @param {Array<LegacyCategory>|null|undefined} legacyCategories - /database response
 * @param {Object<string, string>} pinnedVersions - PINNED_STANDAARD_VERSIONS
 * @returns {Array<LegacyCategory>} Categories with their remaining effects; empty categories are dropped
 */
const withoutPinnedSectors = (legacyCategories, pinnedVersions) => {
    const pinned = new Set(Object.keys(pinnedVersions || {}))
    const isPinned = (effect) => Array.isArray(effect?.sectors) && effect.sectors.some((s) => pinned.has(s))

    return (Array.isArray(legacyCategories) ? legacyCategories : [])
        .map((category) => {
            const effects = Array.isArray(category?.effects) ? category.effects : []
            const kept = effects.filter((effect) => !isPinned(effect))
            return kept.length === effects.length ? category : { ...category, effects: kept }
        })
        .filter((category) => Array.isArray(category?.effects) && category.effects.length > 0)
}

export default withoutPinnedSectors
